import {
  Box,
  Grid,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "../../../styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
  ActionMsg,
  AddButton,
  Breadcrumb,
  CustomePopover,
  DateConversionOnEntryPage,
  DeleteDialog,
  ExcelDownload,
  HandleCloseSnackbar,
  HandleSort,
  SearchInput,
  StyledTableCell,
  StyledTableRow,
  useMessageHandler,
} from "../../reusableComponent/Reusables";
// import { rows } from './../MastersFakeDb';
import {
  editDeleteUOMConversion,
  getUOMConversionList,
} from "../../../actions/actions";
import HeaderSection from "../../reusableComponent/HeaderSection";
import uomConversionMasterService from "../../../services/masters/uomConversionMaster.Service";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";

const UOMConversionList = () => {
  const dispatch = useDispatch();
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.userInfo;

  const [isDelete, setIsDelete] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState();
  const [sortBy, setSortBy] = useState(null);
  const totalCount = useSelector(state => state.uom_conversion.total_count || 0);
  const defaultRowsPerPage = useSelector(state => state.uom_conversion.rows_per_page || 15);
  // const rows = useSelector((state) => state.uom_conversion.uom_conversion);
  const [rows, setRows] = useState([]);
  const [searchKey, setSearchKey] = useState("");

  const fields = ["id", "dress_type", "cost"];
  const labels = ["Id", "dress_type", "cost"];

  const [successMessage, setSuccessMessage] = useState(null);
  // const respMsgState = useSelector((state) => state.uom_conversion.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
  const [controller, setController] = useState({
    page: 0,
    rowsPerPage: defaultRowsPerPage
  });

  useEffect(() => {
    setController(prev => ({
      ...prev,
      rowsPerPage: defaultRowsPerPage,
      page: 0,
    }));
  }, [defaultRowsPerPage]);


  const handleChangePage = (event, newPage) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setController({
      ...controller,
      rowsPerPage: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const fetchData = async () => {
    try {
      const params = {
        page: controller.page,
        size: controller.rowsPerPage,
        searchKey: searchKey,
      };
      const response = await uomConversionMasterService.getUOMConversionList(params);
      setRows(response);
    } catch (error) {
      setSuccessMessage("Error fetching data");
    }
  };

  const handleSearch = (e) => {
    setSearchKey(e.target.value);
    const params = {
      page: controller.page,
      size:
        e.target.value === ""
          ? controller.rowsPerPage
          : rows[0]?.total_count || 0,
      searchKey: e.target.value,
    };
    dispatch(getUOMConversionList(params));
  };

  useEffect(() => {
    fetchData();
  }, [controller]);

  // const { shouldShowMsg, responseMessage } = useMessageHandler(
  //   fetchData,
  //   null,
  //   setSuccessMessage,
  //   respMsgState
  // );

  // useEffect(() => { }, [shouldShowMsg, responseMessage]);

  // const deleteRecord = (id) => {
  //   dispatch(
  //     editDeleteUOMConversion({ uom_con_id: id, changedUpdatedValue: "delete" })
  //   );
  //   setIsDelete(false);
  //   fetchData();
  // };

  const deleteRecord = async (id) => {
    try {
      await uomConversionMasterService.editDeleteUOMConversion({
        uom_con_id: id,
        changedUpdatedValue: "delete"
      });
      setIsDelete(false);
      fetchData();
      setSuccessMessage("Record deleted successfully");
    } catch (error) {
      setSuccessMessage("Error deleting record");
    }
  };

  const handleDelete = (functions) => {
    setIsDelete(true);
    setDeleteInfo(functions);
  };

  const handleClose = (event, reason) => {
    setIsDelete(false);
    setDeleteInfo(null);
  };

  // Sort rows by entry_date descending
  const sortedRows = [...rows].sort((a, b) => new Date(b.entry_date) - new Date(a.entry_date));
  // Calculate pagination info
  const effectiveTotalCount = total_count > 0 ? total_count : rows.length > 0 ? rows.length : 0;
  const startRecord = effectiveTotalCount === 0 ? 0 : controller.page * controller.rowsPerPage + 1;
  const endRecord = effectiveTotalCount === 0 ? 0 : Math.min((controller.page + 1) * controller.rowsPerPage, effectiveTotalCount);
  const paginationInfo = `${startRecord}-${endRecord} of ${total_count}`;


  console.log('Pagination Info:', { startRecord, endRecord, totalCount, effectiveTotalCount, paginationInfo });

  return (
    <Box className={`${styles.cts_page}`} sx={{ padding: "0px !important", margin: "0px !important" }}>
      <Box className={`${styles.body}`}>
        <Breadcrumb
          routeSegments={[
            // { name: 'Dashbord', path: '/dashboard' },
            { name: "UOM Conversion List" },
          ]}
        />


        <HeaderSection
          title="UOM CONVERSION LIST"
          addNewPath="/masters/add-uom-conversion"
          searchKey={searchKey}
          handleSearch={handleSearch}
          sortedRows={sortedRows}
          fields={fields}
          labels={labels}
          filename="UOM Conversion List"
          paginationInfo={paginationInfo}
          controller={controller}
          handleChangePage={handleChangePage}
        />


        <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
          <Table size="small" stickyHeader>
            <TableHead>
              <StyledTableRow>

                <StyledTableCell
                  className={`${styles.table_head}`} align="left" 
                  onClick={() =>
                    HandleSort("prod_group", sortBy, setSortBy, rows)
                  }
                >
                  Product Group
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "prod_group" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>

                <StyledTableCell
                  className={`${styles.table_head}`} align="left" 
                  onClick={() => HandleSort("qty_kg", sortBy, setSortBy, rows)}
                >
                  Qty KG
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "qty_kg" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>

                <StyledTableCell align="left" 
                  className={`${styles.table_head}`}
                  onClick={() => HandleSort("qty_cm3", sortBy, setSortBy, rows)}
                >
                  Qty CM3
                  <span className={`${styles.sort_icon}`}>
                    {" "}
                    {sortBy === "qty_cm3" ? "▲" : "▼"}{" "}
                  </span>
                </StyledTableCell>

                <StyledTableCell align="center" className={`${styles.table_head}`}>
                  Action
                </StyledTableCell>

              </StyledTableRow>
            </TableHead>
            <TableBody sx={{ backgroundColor: '#fff' }}>
              {Array.isArray(rows) &&
                rows.map((row, index) => (
                  <StyledTableRow
                    key={row.name}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >

                    <StyledTableCell
                      className={`${styles.list_table_body}`}
                    >
                      {row.prod_group}
                    </StyledTableCell>

                    <StyledTableCell
                      className={`${styles.list_table_body}`}
                    >
                      {row.qty_kg}
                    </StyledTableCell>

                    <StyledTableCell
                      className={`${styles.list_table_body}`}
                    >
                      {row.qty_cm3}
                    </StyledTableCell>

                    <StyledTableCell align="center">
                      <CustomePopover
                        row={row}
                        handleDelete={false}
                        linkTo="/masters/add-uom-conversion"
                         handlePrint ={false}
                            handleCancel={false}
                            showEdit={false}
                      />
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <DeleteDialog
          open={isDelete}
          handleClose={handleClose}
          deleteInfo={deleteInfo}
          deleteRecord={deleteRecord}
          deleteID={deleteInfo?.uom_con_id || null}
          displayName={deleteInfo?.uom_con_id || ""}
        />
        <ReusableSnackbar
          open={!!successMessage}
          onClose={(event, reason) => {
            if (reason !== 'clickaway') {
              setSuccessMessage("");
            }
          }}
          message={successMessage}
          autoHideDuration={2000}
          vertical="top"
          horizontal="right"
        />
      </Box>
    </Box>
  );
};
export default UOMConversionList;
